import { CrioDivider } from '@crio/crio-react-component/dist/cjs/components/DataDisplay';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import Column from '../Column';
import { Row } from '../index';

const StyledEmptyProcedurePreviewPage = styled(Column)`
  background-color: ${(props) => props.theme.palette.grey[50]};
  padding-left: 40px;
  padding-right: 40px;
  
  .fa-circle-exclamation {
    padding-right: 8px;
    color: ${(props) => props.theme.palette.grey[600]};
  }
    
  .MainMessage {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.palette.grey[700]};
    font-style: italic;
  }
    
  .MessageRow {
    height: 61px;
    align-items: center;
  }
`;

export default function EmptyProcedurePreviewPage() {
  const { t } = useTranslation();
  return (
    <StyledEmptyProcedurePreviewPage>
      <Row className="MessageRow">
        <FontAwesomeIcon icon={faExclamationCircle} size="sm" />
        <span className="MainMessage">
          {t('Procedure.Procedure Preview.Empty procedure description')}
        </span>
      </Row>
      <CrioDivider />
    </StyledEmptyProcedurePreviewPage>
  );
}
